import React from "react";

const Illustration_BG_BR = (props: any) => {
  return (
    <svg
      width="377"
      height="347"
      viewBox={`0 0 ${props.width || 377} ${props.height || 347}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M380 0C346.41 18.8545 298.922 14.5164 264.586 35.5106C249.895 44.5403 238.31 57.8462 231.382 73.6475C223.644 91.386 222.161 111.407 214.423 129.095C200.843 160.033 170.179 179.684 139.682 194.175C109.186 208.667 76.4845 220.313 51.3361 242.843C21.9461 269.191 6.11943 307.957 0 347H380V0Z"
        fill="#F0F5FF"
      />
    </svg>
  );
};

export default Illustration_BG_BR;
